export const ownerscabinImageOptions = {
  angle: 'ownerscabin',
  staticOptions: {
    Veneer: 1,
    Floorboard: 1,
    Handrail: 1,
    Worktop: 1,
    Fabric: 1,
    CupboardsSaloon: 1,
    CupboardsOwnersCabin: 1,
    FabricOwnersCabin: 1,
    FabricAftCabin: 1,
    AftCabinLayout: 1,
    Mast: 1
  },
  mattes: [
    {
      option: 'Veneer',
      dependency: null
    },
    {
      option: 'CupboardsOwnersCabin',
      dependency: 'Veneer'
    },
    {
      option: 'FabricOwnersCabin',
      dependency: null
    }
  ]
}



// WEBPACK FOOTER //
// ./src/X43/views/ownerscabin.js